import http from "../../http-common";

export default class {
  getMyPrograms(userId: string) {
    let url = `/events/myprogram/${userId}`;

    return http.get(url);
  }
}